export const MOUSE_ENTER = 'MOUSE_ENTER'
export const MOUSE_LEAVE = 'MOUSE_LEAVE'
export const MOUSE_ACTIVE = 'MOUSE_ACTIVE'
export const MOUSE_DISABLE = 'MOUSE_DISABLE'
export const MOUSE_CLOSE = 'MOUSE_CLOSE'
export const MOUSE_DEFAULT = 'MOUSE_DEFAULT'
export const MOUSE_DARK_MODE = 'MOUSE_DARK_MODE'
